/**
 * ProgressCircle – SVG icon.
 */

interface Props {
  percentage?: number;
  strokeColor?: string;
  text?: string;
  textColor?: string;
}

/** Circular progress indicator with optional percentage and label. */
export default function ProgressCircleIcon({
  percentage,
  strokeColor,
  text,
  textColor,
}: Props) {
  return (
    <svg viewBox='0 0 90 90'>
      {percentage ? (
        <path
          d='M45 5 a 40 40 0 0 1 0 80 a 40 40 0 0 1 0 -80'
          fill='none'
          strokeLinecap='round'
          strokeWidth='6'
          stroke='grey'
        />
      ) : null}
      <path
        d='M45 5 a 40 40 0 0 1 0 80 a 40 40 0 0 1 0 -80'
        fill='none'
        strokeLinecap='round'
        strokeWidth={percentage ? '6' : '5'}
        stroke={strokeColor || '#ffff'}
        strokeDasharray={
          percentage
            ? `${percentage * 251.2},${251.2 - percentage * 251.2}`
            : ''
        }
      />
      {text ? (
        <text
          id='progressCircleText'
          x='45'
          y='45'
          dy='12'
          fill={textColor || '#ffff'}
          fontSize={text?.length > 3 ? 28 : 34}
          textAnchor='middle'
        >
          {text}
        </text>
      ) : null}
    </svg>
  );
}
